import { useContext } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';

import { ExtranetFeedbacks } from './Legacy/ExtranetFeedbacks';
import { ExtranetReviews } from './Modern/ExtranetReviews';

export const ReviewsRouter = () => {
  const { hotelLoading, hotelInfo, isLegacy } = useContext(HotelContext);

  if (hotelLoading || !hotelInfo) {
    return null;
  }

  return isLegacy ? <ExtranetFeedbacks /> : <ExtranetReviews />;
};
